import React from 'react';
import { ControlProps, components } from 'react-select';
import { Icon } from 'view/atoms';

export const ControlWithIcon =
  <T,>(src: string) =>
  ({ children, ...props }: ControlProps<T>) =>
    (
      <components.Control {...props}>
        <Icon style={{ marginLeft: '8px' }} src={src} />
        {children}
      </components.Control>
    );
